import type { AccountSettingsLinkError } from '@/lib/accountSettings';
import { providerLabel } from '@/lib/accountLinking';

export { SIGN_IN_METHODS_FAQ_PATH } from '@/lib/signInMethodsFaq';

export const SUPPORT_EMAIL = 'hello@globethrivers.com';

export const PASSWORD_SET_MESSAGE = 'Password set. You can now sign in with your email and password.';
export const PASSWORD_CHANGED_MESSAGE = 'Password changed. Use your new password next time you sign in with email.';

export function linkErrorMessage(code: AccountSettingsLinkError, provider: 'google' | 'apple' | null): string {
  const label = provider ? providerLabel(provider) : 'Google or Apple';
  if (code === 'ACCOUNT_LINK_REQUIRED') {
    return `That ${label} account's email belongs to a separate Globe Thrivers account. Contact ${SUPPORT_EMAIL} to merge them.`;
  }
  return `Could not connect ${label}. Try again.`;
}
